import React, { useContext, useEffect, useState } from 'react'
import MUIDataTable from "mui-datatables";
import styled from '@emotion/styled';
import ProfileContext from '../../../context/ProfileContext';
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import useAuth from '../../../hooks/useAuth';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
const muiCache = createCache({
	"key": "mui",
	"prepend": true
});


const StyledMUIDataTable=styled(MUIDataTable)(({theme})=>({
  background:theme.palette.background.default,
  //     '& .css-1nrlq1o-MuiFormControl-root':{
  //      padding:'16px 24px',
  // },
  // '& .css-1w1rijm-MuiButtonBase-root-MuiButton-root':{
  //   padding:'0px'
  // },
  // '& .css-nfmglb-MuiTableCell-root':{
  //   padding:'0px'
  // },
  //  '& .tss-1vsygk-MUIDataTableFilterList-root':{
  //   gap:'8px',
  //   marginBottom:'5px'

  // },
}))
export default function CoursePreferenceTable(props) {
  const {changed}=useAuth();
  const api=useAxiosPrivate()
  const option = {
  filterType: 'multiselect',
  selectableRows:"none",
  rowsPerPage:5,
  rowsPerPageOptions:[5,10,20,40],
  rowHover:false,
  // responsive:'scroll',
};
  const [data,setData]=useState([])
   useEffect(()=>{
      let isMounted=true;
      const controller=new AbortController();
      const getData=async ()=>{
        try{
          const response=await api.get(`courseOffering/viewChoicesList`,{
            signal:controller.signal
          })
          console.log(response.data)
          isMounted &&  setData(response.data)}
        catch(err){
          console.error(err)
        }
      }
      getData();
      return ()=>{
        isMounted=false;
        controller.abort()
      }
        },[changed])
  const columns = [
  {
  name: "year",
  label: "Academic Year",
  options: {
   filter: true,
   sort: true,
  }
 },
 {
  name: "semester",
  label: "Semester Term",
  options: {
   filter: true,
   sort: true,
  }
 },
 {
  name: "first_choice",
  label: "First Choice",
  options: {
   filter: true,
   sort: true,
  }
 },
 {
  name: "second_choice",
  label: "Second Choice",
  options: {
   filter: true,
   sort: true,
  }
 },
 {
   name: "third_choice",
   label: "Third Choice",
   options: {
     filter: true,
     sort: true,

     }
   },
   {
   name: "type",
   label: "Type",
   options: {
     filter: true,
     sort: true,

     }
   },
]
 return(
  <CacheProvider value={muiCache}>
  <StyledMUIDataTable
  title="Course Preference History"
  data={data}
  columns={columns}
  options={option}
/></CacheProvider>
 )} 